import { createSlice } from "@reduxjs/toolkit";

export const buildVersionSlice = createSlice({
  name: "buildversionslice",
  initialState: {
    loading: false,
    error: null,
    versionNum: null,
  },
  reducers: {
    setStateLoading(state) {
      state.loading = true;
    },
    revertStateLoading(state) {
      state.loading = false;
    },
    setVersionNum(state, action) {
      state.loading = false;
      state.error = false;
      state.versionNum = action.payload ?? {};
    },
  },
});

export const {
    setStateLoading,
    revertStateLoading,
    setVersionNum
  
} = buildVersionSlice.actions;

export default buildVersionSlice.reducer;
